import { formatNumber } from "@buildpy/core/lib/format";
import { formatBytes, type UsageMeter } from "@buildpy/core/modules/plan/usage-limit";

// 「0.62GB / 1GB」 · 한도가 없으면 「0.62GB / 제한 없음」.
export const storageAmountOf = (meter: UsageMeter): string =>
  `${formatBytes(meter.used)} / ${meter.limit === null ? "제한 없음" : formatBytes(meter.limit)}`;

// 「18건 / 30건」.
export const notifyAmountOf = (meter: UsageMeter): string =>
  `${formatNumber(meter.used)}건 / ${meter.limit === null ? "제한 없음" : `${formatNumber(meter.limit)}건`}`;

// 막대 폭 — 100% 를 넘으면 꽉 찬 막대.
export const barPercentOf = (meter: UsageMeter): number => (meter.rate === null ? 0 : Math.min(100, Math.round(meter.rate * 100)));
